var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.9204 13.2696C20.5166 13.2696 21 12.7863 21 12.19L21 11.8091C21 11.2129 20.5166 10.7295 19.9204 10.7295L4.07963 10.7295C3.48337 10.7295 3 11.2129 3 11.8091L3 12.19C3 12.7863 3.48337 13.2696 4.07963 13.2696L19.9204 13.2696Z"
})));
export { SvgMinus as ReactComponent };